<template>
  <div v-if="password" class="flex items-center gap-2">
    <div class="flex-1 h-1 bg-gray rounded-full overflow-hidden">
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="barColor"
        :style="{ width: barWidth }"
      ></div>
    </div>
    <span class="text-sm font-semibold shrink-0" :class="labelColor">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'PasswordStrength',
  props: {
    password: {
      type: String,
      default: null,
    },
  },
  watch: {
    level(val) {
      this.$emit('input', val)
    },
  },
  computed: {
    score() {
      const p = this.password || ''
      let score = 0
      if (p.length >= 8) score++
      if (p.length >= 12) score++
      if (/[A-Z]/.test(p)) score++
      if (/[0-9]/.test(p)) score++
      if (/[^A-Za-z0-9]/.test(p)) score++
      return score
    },
    level() {
      if (this.score <= 1) return 'weak'
      if (this.score === 2) return 'fair'
      if (this.score === 3) return 'good'
      return 'strong'
    },
    label() {
      return { weak: 'Weak', fair: 'Fair', good: 'Good', strong: 'Strong' }[this.level]
    },
    barWidth() {
      return { weak: '25%', fair: '50%', good: '75%', strong: '100%' }[this.level]
    },
    barColor() {
      return {
        weak: 'bg-red-100',
        fair: 'bg-orange-100',
        good: 'bg-green-80',
        strong: 'bg-green-100',
      }[this.level]
    },
    labelColor() {
      return {
        weak: 'text-red-100',
        fair: 'text-orange-100',
        good: 'text-green-80',
        strong: 'text-green-100',
      }[this.level]
    },
  },
}
</script>
